module.exports = __webpack_public_path__ + "img/facility_6.19a949ae.jpg";